import { horizontalListSortingStrategy, rectSortingStrategy, rectSwappingStrategy, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

type DroppableProps = {
    id? :  string 
    items: any[];
    orientation: 'horizontal' | 'vertical' | 'sorting' | 'swap';
    children: React.ReactNode;
}

 function Droppable({ id,  items, orientation, children }: DroppableProps) {
    let strategy = verticalListSortingStrategy;
    switch (orientation) {
        case 'horizontal':
            strategy = horizontalListSortingStrategy;
            break
        case 'vertical':
            strategy = verticalListSortingStrategy;
            break;
        case 'sorting':
            strategy = rectSortingStrategy;
            break;
        case 'swap':
            strategy = rectSwappingStrategy;
            break;
    }
    return <SortableContext id={id} items={items} strategy={strategy}>
        {children}
    </SortableContext>

}
export default Droppable;